
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-production/crypto-explainer-video",
      function () {
        return require("private-next-pages/video-production/crypto-explainer-video/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-production/crypto-explainer-video"])
      });
    }
  